import { Sector } from '@/domain/impact/impact.entity';
import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { CalculateFestivalEnv } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';
import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';
import { translate } from '@/ui/i18n';

export function prepareData(
  calculateCo2: CalculateFestivalCo2,
  calculateEnv: CalculateFestivalEnv,
  calculateEss: CalculateFestivalEss,
) {
  return [
    {
      title: translate('Projects.team'),
      sector: 'TEAM' as Sector,
      scores: {
        co2: calculateCo2.sectors.team.score,
        env: getScoreLetterFromScore(
          calculateEnv.sectors.TEAM.score / calculateEnv.sectors.TEAM.maxScore,
        ),
        ess: getScoreLetterFromScore(
          calculateEss.sectors.TEAM.score / calculateEss.sectors.TEAM.maxScore,
        ),
      },
    },
    {
      title: translate('Projects.artists'),
      sector: 'ARTISTS' as Sector,
      scores: {
        co2: calculateCo2.sectors.artists.score,
        env: getScoreLetterFromScore(
          calculateEnv.sectors.ARTISTS.score /
            calculateEnv.sectors.ARTISTS.maxScore,
        ),
        ess: getScoreLetterFromScore(
          calculateEss.sectors.ARTISTS.score /
            calculateEss.sectors.ARTISTS.maxScore,
        ),
      },
    },
    {
      title: translate('Projects.public'),
      sector: 'PUBLIC' as Sector,
      scores: {
        co2: calculateCo2.sectors.public.score,
        env: getScoreLetterFromScore(
          calculateEnv.sectors.PUBLIC.score /
            calculateEnv.sectors.PUBLIC.maxScore,
        ),
        ess: getScoreLetterFromScore(
          calculateEss.sectors.PUBLIC.score /
            calculateEss.sectors.PUBLIC.maxScore,
        ),
      },
    },
    {
      title: translate('Projects.site'),
      sector: 'SITE' as Sector,
      scores: {
        co2: calculateCo2.sectors.site.score,
        env: getScoreLetterFromScore(
          calculateEnv.sectors.SITE.score / calculateEnv.sectors.SITE.maxScore,
        ),
        ess: getScoreLetterFromScore(
          calculateEss.sectors.SITE.score / calculateEss.sectors.SITE.maxScore,
        ),
      },
    },
  ];
}
